import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ToggleableButton from "../../../components/toggleableButton/toggleableButton";
import { actionCreators } from "../redux/checkInSaga";

const ShowPercentageToggle = () => {
  const dispatch = useDispatch();
  const showPercentage = useSelector((state) => state.checkIns.selectedFilters.show_percentage);
  const showPercentageToggle = useSelector((state) => state.checkIns.showPercentageToggle);

  return showPercentageToggle ? (
    <div className="check-in-toggle">
      <p>Show percentage</p>
      <ToggleableButton
        title="Show percentage"
        isRadio
        isActive={showPercentage}
        onClick={(isActive) => dispatch(actionCreators.onChangePercentageToggle(isActive))}
      />
    </div>
  ) : null;
};

export default ShowPercentageToggle;
